import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import { canUserApprove } from "./utils";

interface ApproveMovementProps {
  movementFlowData?: {
    id: string;
    task: { status: string; claimOwnerName: string } | null;
    status: string;
    terminalReport: { report: string } | null;
    to: string;
    from: string;
  };
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.movement-services";

const ApproveMovement: React.FC<ApproveMovementProps> = ({ movementFlowData, openDrawer }) => {
  if (!movementFlowData || !movementFlowData.task) {
    return null;
  }

  const isActionAvailable = canUserApprove(
    movementFlowData.task.status,
    movementFlowData.task.claimOwnerName,
    movementFlowData.status,
    movementFlowData.to,
  );

  const handleApproveClick = () => {
    openDrawer("approveDrawer");
  };
  return (
    <ApproveButton
      langBase={LANG_BASE}
      permission="canApproveMovementService"
      isActionAvailable={isActionAvailable}
      onApprove={handleApproveClick}
    />
  );
};
export default ApproveMovement;
